import { render } from "./CertCardPrintModal.vue?vue&type=template&id=2989a954&scoped=true"
import script from "./CertCardPrintModal.vue?vue&type=script&lang=js"
export * from "./CertCardPrintModal.vue?vue&type=script&lang=js"

import "./CertCardPrintModal.vue?vue&type=style&index=0&id=2989a954&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2989a954"]])

export default __exports__